import { defineMessages } from 'react-intl'

export const globalLang = defineMessages({
    copyNotification: {
        id: 'global.copy-notification',
        defaultMessage: 'Copied to clipboard',
    },
    brokerName: {
        id: 'global.broker_name',
        defaultMessage: 'Broker Name',
    },
    codeSentNotification: {
        id: 'global.code_sent_notification',
        defaultMessage: 'Code sent',
    },
    networkError: {
        id: 'global.network_error',
        defaultMessage: 'Oops!',
    },
    somethingWrong: {
        id: 'global.something_wrong',
        defaultMessage: 'Oops! Something went wrong',
    },
    proLinkText: {
        id: 'global.pro_link.text',
        defaultMessage: '{brokerName} Plus',
    },
    proLinkHref: {
        id: 'global.pro_link.href',
        defaultMessage: 'pro_link',
    },
    contactSupport: {
        id: 'global.contact_support',
        defaultMessage: 'Contact support',
    },
    contactSupportLink: {
        id: 'global.contact_support_link',
        defaultMessage: 'support_link',
    },
    emailSupportLink: {
        id: 'global.email_support_link',
        defaultMessage: 'support_email?{userId}{userCountry}',
    },
    supportEmail: {
        id: 'global.support_email',
        defaultMessage: 'Support email',
    },
    walletIdDomain: {
        id: 'global.wallet_id_domain',
        defaultMessage: '.wallet_id.id',
    },
    buyTemporarilyDisabled: {
        id: 'global.buy_feature_unavailable_tooltip',
        defaultMessage: 'Sorry, buy feature is temporarily disabled',
    },
    soon: {
        id: 'global.soon',
        defaultMessage: 'Soon',
    },
    comingSoon: {
        id: 'global.coming_soon',
        defaultMessage: 'Coming soon!',
    },
    comingSoonTooltip: {
        id: 'global.coming_soon_tooltip',
        defaultMessage:
            'A new feature in the app that allows you to buy cryptocurrencies with cash! Stay tuned for the latest updates.',
    },
    walletId: {
        id: 'global.wallet_id',
        defaultMessage: 'Wallet ID',
    },
    address: {
        id: 'global.address',
        defaultMessage: 'Address',
    },
    email: {
        id: 'global.email',
        defaultMessage: 'Email',
    },
    clientId: {
        id: 'global.client_id',
        defaultMessage: 'Client ID',
    },
    ens: {
        id: 'global.ens',
        defaultMessage: 'ENS',
    },
    network: {
        id: 'global.network',
        defaultMessage: 'Network',
    },
    termsLink: {
        id: 'global.terms_link',
        defaultMessage: '#',
    },
    privacyLink: {
        id: 'global.privacy_link',
        defaultMessage: '#',
    },
    zeroFee: {
        id: 'global.zero.fee',
        defaultMessage: '⚡️ Zero fees',
    },
    buy: {
        id: 'global.buy',
        defaultMessage: 'Buy',
    },
    receive: {
        id: 'global.receive',
        defaultMessage: 'Receive',
    },
    transfer: {
        id: 'global.transfer',
        defaultMessage: 'Transfer',
    },
    topUp: {
        id: 'global.topUp',
        defaultMessage: 'Top up',
    },
    send: {
        id: 'global.send',
        defaultMessage: 'Send',
    },
    swap: {
        id: 'global.swap',
        defaultMessage: 'Swap',
    },
    threeDSLink: {
        id: 'global.3ds.link',
        defaultMessage: '3ds_link',
    },
    captchaSkipError: {
        id: 'global.captcha.skip_error',
        defaultMessage: 'Verification was skipped',
    },
})
